import { FolderKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { BrowseFolderRequest, BrowseFolderResponse } from "@maven-rest/docs/Folder.dto";
import { FolderUrl } from "@maven-rest/docs/Folder.url";

export function useBrowseFoldersQuery(req: BrowseFolderRequest, options?: SimpleQueryOptions<BrowseFolderResponse, BrowseFolderRequest>) {
  return useBaseQuery({
    queryKey: [FolderKey.BrowseFolders, req.folderType, String(req.organizationId), req.name, req.includeDeletedResource],
    fnOption: {
      url: FolderUrl.browseFolders,
      request: req,
    },
    ...options,
  });
}
